import { CMSService } from 'client/services';

const loader = async () => {
    const terms = await CMSService.getTsAndCs();
    return { terms };
};

export default loader;
